angular.module('unica_invitation_group.invitation_group_services')

.factory('InvitationGroupListService', function($http, getBaseApiURL) {

	var invitationGroupListService = {};

	invitationGroupListService.list = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationGroups;
			}

		});
	};

	invitationGroupListService.get = function (invitationGroupId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/detail/' + invitationGroupId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationGroup;
			}

		});

	};

	return invitationGroupListService;

});